import { useQuery } from '@tanstack/react-query'
import { lookupsApi } from '@/api/endpoints'

/** Reference data changes rarely — one call, cached for an hour, shared by every screen. */
export const useLookups = () =>
  useQuery({
    queryKey: ['lookups'],
    queryFn: lookupsApi.all,
    staleTime: 60 * 60 * 1000,
    gcTime: 24 * 60 * 60 * 1000,
  })
